import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from '../../../../core-services/authentication/auth.service';
import { DeactivateDetails } from '../../../models/UserDeactivate.model';
import { PopupTriggerService } from '../../../../core-services/core/popup-trigger.service';
import { ToastService } from '../../../../core-services/shared/toast.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-deactivate-popup',
  standalone: true,
  imports: [FormsModule, MatIconModule],
  templateUrl: './deactivate-popup.component.html',
  styleUrl: './deactivate-popup.component.scss',
})
export class DeactivatePopupComponent {
  reason = '';
  enterpriseId: any = null;
  constructor(
    private dialogRef: MatDialogRef<DeactivatePopupComponent>,
    private authService: AuthService,
    private popupService: PopupTriggerService,
    private toastService: ToastService,
    private msalService: MsalService,
  ) {}

  submitDeactivation() {
    this.enterpriseId = this.authService.getUserDetails().enterpriseId;
    const deactivateUser: DeactivateDetails = {
      EnterpriseId: this.enterpriseId,
      isActive: false,
      comments: this.reason,
    };

    if (deactivateUser != null) {
      this.popupService.DeactivateUserkDetails(deactivateUser).subscribe({
        next: (response) => {
          if (response.IsSuccess) {
            // console.log('User deactivated successfully', response);
            this.toastService.success('User deactivated successfully!!');
            this.dialogRef.close();
            // Open agree popup
          }
          this.msalService.logoutRedirect({
            postLogoutRedirectUri: '/',
          });
        },
        error: (err) => {
          console.error('Error in User deactivation:', err);
          // this.toastService.error(response);
        },
      });
    } else {
      console.error('DeactivateDetails is null');
      this.toastService.error('Failed to deactivate user. Please try again.');
    }
  }

  close(event: MouseEvent): void {
    event.preventDefault(); // Prevents page reload from the href="#"
    this.dialogRef.close();
  }
}
